import CommonErrorPage from "./Common/CommonErrorPage";

const Error503 = () => {
  return <CommonErrorPage color="secondary" page="503" />;
};

export default Error503;
